/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { Link, useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { FaStar } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';

const CategoryDetails = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

    const [labList, setLabList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [page, setPage] = useState(1);
    const [totallength, setTotalLength] = useState(0);

    const hasReachedBottom = useRef(false);
    const NoMoreDataRef = useRef(true);
    const navigate = useNavigate();

    const Data = sessionStorage.getItem("Docdetails");
    if (Data) {
        var { Categoryid, title } = JSON.parse(Data);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        navigator.geolocation.getCurrentPosition(position => {
            const lat = String(position.coords.latitude);
            const long = String(position.coords.longitude);
            setLatitude(lat);
            setLongitude(long);
            fetchHomeData(lat, long, 1);
        });
    }, [Categoryid]);


    const fetchHomeData = (lat, long, page) => {
        axios.post(`${ApiBaseUrl}/customer/category_lab_list`, { category_id: Categoryid, lat: lat, lon: long, page })
            .then((res) => {
                // console.log("category_lab_list", res);
                const { ResponseCode, lab_list } = res.data;
                if (ResponseCode === 200) {

                    if (lab_list.length === 0 || totallength > lab_list.length) {
                        NoMoreDataRef.current = false;
                    }

                    if (page === 1) {
                        setLabList(lab_list);
                        setTotalLength(lab_list.length);
                    } else {
                        setLabList(page === 1 ? lab_list : [...labList, ...lab_list]);
                    }
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            const clientHeight = window.innerHeight;

            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

            if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
                hasReachedBottom.current = true;
                setPage(prevPage => prevPage + 1);
            } else if (!isAtBottom && hasReachedBottom.current) {
                hasReachedBottom.current = false;
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (page === 1 || !NoMoreDataRef.current) return;
        fetchHomeData(latitude, longitude, page);
    }, [page]);

    const HandleNavigate = (item) => {
        navigate("/packages");
        sessionStorage.setItem("Docprofile", JSON.stringify({ Categoryid: Categoryid, Labid: item.id, title: title, path: "/category-details" }));
    };

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto";
    }, [loading]);

    return (
        <div className='width-container pb-[50px] lab-details'>
            {loading
                ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className="">
                    <div className="flex items-center justify-between top-section max-_430_:hidden">
                        <Link to="/" className="flex items-center gap-[5px] border-[2px] border-gray-200 rounded-[50px] px-[10px] group py-[4px] hover:bg-black">
                            <IoIosArrowBack className=' group-hover:text-white' />
                            <h1 className='font-[500] group-hover:text-white'> {t("Go Home")}</h1>
                        </Link>
                        <div className="flex items-center gap-[10px]">
                            <Link to="/lab-details" className='font-[500] text-gray-700'>{t("Lab Details")}</Link>
                            <IoIosArrowForward />
                            <h1 className='font-[500] text-gray-400 pagename'>{title}</h1>
                        </div>
                    </div>

                    <div className="mt-[30px] flex flex-wrap items-center gap-[20px]">
                        {labList.length >= 1
                            ? labList.map((item, index) => {
                                return <div onClick={() => HandleNavigate(item)} key={index} className="card-box">
                                    <div className="">
                                        <img className='photo object-cover' src={ImgBaseUrl + item.logo} alt="Logo" />
                                    </div>
                                    <div className="p-[10px]">
                                        <h1 className='text-[18px] font-[500]'>{item.name}</h1>
                                        <p className='text-[15px] leading-[18px] whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.address}</p>
                                        <div className="mt-[5px] flex items-center justify-between">
                                            <div className="">
                                                <h1 className='flex items-center gap-[5px] font-[500]'><FaStar className='text-orange-400 text-[17px]' />{item.avg_star} <span className='text-gray-500 font-[400]'>({item.tot_review || 0})</span> </h1>
                                            </div>
                                            <div className="flex items-center gap-[5px]">
                                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z" fill="black" />
                                                </svg>
                                                <h1 className='text-gray-600 text-[15px]'>{item.distance} KM</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })
                            : <div className='w-[100%] h-[300px] flex items-center justify-center'>
                                <h1 className='font-[500] text-[20px]'>{t("No Lab available in your area.")}</h1>
                            </div>}
                    </div>
                </div>}
        </div>
    )
}

export default CategoryDetails
/* jshint ignore:end */